<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Artikal</label>
                    <div class="col-lg-7 col-xl-6">
                      <label>{{ review.articleTitle }}</label>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Korisnik</label>
                    <div class="col-lg-7 col-xl-6">
                      <label>{{ review.user || 'Nesto' }}</label>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Ocjena</label>
                    <div class="col-lg-7 col-xl-6">
                      <label>{{ review.rating }}</label>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Komentar</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        rows="3"
                        v-model="review.comment"
                        class="form-control form-control-modern"
                        placeholder="Komentar"
                      ></textarea>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Odgovor</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        rows="3"
                        v-model="review.replyOnComment"
                        class="form-control form-control-modern"
                        placeholder="Odgovor"
                      ></textarea>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Komentar odobren?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="review.isApproved"
                        id="is-approved"
                      />
                      <label for="is-approved"></label>
                    </div>
                  </div>
                </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Datum</label>
                    <div class="col-lg-7 col-xl-6">
                      <label>{{ formatDate(review.createdDate || new Date(), 'dd.MM.yyyy HH:mm:ss') }}</label>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-end gap-3">
        <router-link exact :to="{ name: 'Reviews' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
          {{ translations.cancel }}
        </router-link>
        <button
          type="submit"
          class="
            submit-button
            btn btn-primary btn-px-4
            py-3
            d-flex
            align-items-center
            font-weight-semibold
            line-height-1
          "
          data-loading-text="Loading..."
        >
          <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
        </button>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { format } from 'date-fns';
import { translations } from '@/mixins';
import api from '@/services/api';

export default {
  name: 'EditReview',
  mixins: [translations],
  computed: {
    review() {
      return this.$store.getters.getReview;
    },
  },
  mounted() {
    this.$store.dispatch('getReview', this.$route.params.id);
  },
  methods: {
    formatDate(date, dateFormat) {
      return format(new Date(date), dateFormat);
    },
    submitForm() {
      const { review } = this;

      api.updateReview(review)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Reviews' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
  },
};
</script>